import React, { useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";

import DailyYeildDataProduction from "./AMChart/DailyYeildDataProduction";
// import Chart2 from "./AMChart/chart2";
// import Chart3 from "./AMChart/chart3";
import { useSelector } from "react-redux";

import CompareYeildDataProduction from "./AMChart/CompareYeildDataProduction";
import useFetch from "../../Controllers/useFetch";
import { Spin } from "antd";
import { gql, useQuery } from "@apollo/client";
import HomePageDatePicker from "./AMChart/DatePicker";
import dayjs from "dayjs";
import moment from "moment-jalaali";
import MonthlyYeildDataProduction from "./AMChart/MonthlyYeildDataProduction";
import YearlyYeildDataProduction from "./AMChart/YearlyYeildDataProduction";
import TotalYeildDataProduction from "./AMChart/TotalYieldDataProduction";
import { format } from "path";
import { error as ToastError } from "../../Controllers/toast";

var time_interval = 1;

const DAILY_SCHEMA = gql`
  query (
    $plant_id: Int!
    $date_time: Date!
    $time_interval: Int!
    $time_offset: Int!
    $gateway: Boolean
  ) {
    DailyYeildDataProduction(
      plant_id: $plant_id
      date_time: $date_time
      time_interval: $time_interval
      time_offset: $time_offset
      gateway: $gateway
    ) {
      date_time
      Ppv
      Pline
      Pbat
      SOC
    }
    MonthlyYeildDataProduction(plant_id: $plant_id, date_time: $date_time) {
      date_time
      energy
    }
    TotalyYeildDataProduction(plant_id: $plant_id, date_time: $date_time) {
      date_time
      energy
    }
    YearlyYeildDataProduction(plant_id: $plant_id, date_time: $date_time) {
      date_time
      energy
    }
  }
`;
const d = new Date()
const FinallyChart = (props) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const [dateHOC, setDateHOC] = useState(new Date());
  const [dailyChartData, setDailyChartData] = useState([]);
  const [monthlyChartData, setMonthlyChartData] = useState([]);
  const [yearlyChartData, setYearlyChartData] = useState([]);
  const [totalyChartData, setTotalyChartData] = useState([]);

  const time_offset = parseInt(new Date(dateHOC).getTimezoneOffset());


  const {
    error,
    loading: loadingDaily,
    refetch,
  } = useQuery(DAILY_SCHEMA, {
    variables: {
      plant_id: parseInt(props.plant_id),
      date_time: dateHOC,
      time_interval,
      time_offset,
      gateway: true,
    },
    onCompleted: (res) => {
      // console.log(res.DailyYeildDataProduction, "is DailyYeildDataProduction");

      const dailyChartDataFuction = res.DailyYeildDataProduction.filter(obj => !(obj.Ppv === 0 && obj.Pline === 0 && obj.Pbat === 0 && obj.SOC === 0)).map((obj) => {
        // console.log(obj)
        const d = new Date(parseInt(obj.date_time));
        const d2 = new Date(
          moment(d).locale("fa").format("jYYYY-jMM-jDD HH:mm")
        );
        // console.log(d2);
        return {
          Ppv: (Math.round(obj.Ppv / 100000) / 1000),
          Pline: (Math.round(obj.Pline / 10000) / 1000),
          Pbat: (Math.round(obj.Pbat / 100000) / 1000),
          SOC: (Math.round(obj.SOC / 100)),
          date_time: d2,
        };
      });

      const monthlyChartDataFunction = res.MonthlyYeildDataProduction.map(
        (obj) => {
          const d = new Date(parseInt(obj.date_time));
          const d2 = new Date(moment(d).locale("fa").format("jYYYY-jMM-jDD"));
          if (
            new Date(
              moment(new Date()).locale("fa").format("jYYYY-jMM-jDD")
            ).getDate() === d2.getDate()
          ) {
            props.totalPlantProductions(
              ((obj.energy) / 1000).toFixed(2)
            );
          }
          return {
            energy: Math.round(obj.energy / 10) / 100,
            date_time: d2,
          };
        }
      );
      let totalYearlyProduction = 0;
      // console.log(res.YearlyYeildDataProduction , 'is yearly')
      const yearlyChartDataFuction = res.YearlyYeildDataProduction.map((obj) => {
        const m = moment(obj.date_time); // میلادی از بک‌اند
        const jalaliMonth = m.format("jMMMM"); // ماه شمسی
        const jalaliYear = m.format("jYYYY");
      
        console.log(obj.energy, jalaliMonth, jalaliYear);
      
        totalYearlyProduction += Math.round(obj.energy);
      
        return {
          energy: Math.round(obj.energy).toFixed(2),
          month: jalaliMonth, // مثلاً "مهر"
        };
      });
      
      
      props.setTotalYearlyProduction(totalYearlyProduction);
      const totalyChartDataFuction = res.TotalyYeildDataProduction.map(
        (obj) => {
          // console.log(obj.date_time , "is TotalyYield")
          const d = (new Date(parseInt(obj.date_time)));
          const d2 = moment(d).format("jYYYY")
          const currentDate = new Date()
          const dayOfYear = Math.floor((currentDate - new Date(currentDate.getFullYear(), 0, 0)) / (24 * 60 * 60 * 1000));
          return {
            energy: (
              (obj.energy)/1000
            ).toFixed(2),
            year: d2,
          };
        }
      );
      setDailyChartData(dailyChartDataFuction);
      setMonthlyChartData(monthlyChartDataFunction);
      setTotalyChartData(totalyChartDataFuction);
      setYearlyChartData(yearlyChartDataFuction);
      // console.log(new Date(dateHOC).getDate(),(new Date()).getDate())
      if (dailyChartDataFuction.length > 0 && new Date(dateHOC).getDate() === (new Date()).getDate())
        setTimeout(() => {
          props.MaximumDataProd(
            Math.max(...dailyChartDataFuction.map((o) => o.Ppv))
          );
          props.setBatteryPower(dailyChartDataFuction[dailyChartDataFuction.length - 2]?.Pbat)
        }, 1000)
      // console.log("HASAN", loading)
      // console.log("data", data)
      // console.log("error", error)
    },
    onError: (err) => {
      ToastError("مشکلی در دریافت اطلاعات رخ داده است!")
      console.log(err);
    },
    pollInterval: 1 * 60 * 1000,
  });
  // const { data, isLoading } = useFetch(
  //   "static_charts",
  //   "get",
  //   "/dashboard/chart",
  //   0
  // );

  // const dispatch = useDispatch();

  toggle = toggle.bind(this);

  const [activeTab, setActiveTab] = useState(new Array(5).fill("1"));

  function toggle(tabPane, tab) {
    const newArray = activeTab.slice();
    newArray[tabPane] = tab;
    setActiveTab(newArray);
  }

  const handleDateChange = (date) => {
    // console.log(moment(date, "jYYYY-jMM-jDD").format("YYYY-MM-DD"),date , "is sending date");

    refetch({
      plant_id: parseInt(props.plant_id),
      date_time: moment(date, "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
      time_interval,
      time_offset,
    });
  };

  function tabPane() {
    // if (loadingDaily === true) {
    //   // return (
    //   //   <Spin
    //   //     spinning={true}
    //   //     size={"large"}
    //   //     style={{ position: "relative", top: "150px" }}
    //   //   >
    //   //     در حال بارگذاری ...
    //   //   </Spin>
    //   // );
    // } else {
    // console.log(data);
    return (
      <>
        {" "}
        <TabPane tabId="1">
          <div className="text-center mt-2">
            <HomePageDatePicker
              dateHOC={dateHOC}
              setDateHOC={(date) => {
                // console.log(date);
                setDateHOC(moment(date, "jYYYY-jMM-jDD").format("YYYY-MM-DD"));
                handleDateChange(date);
              }}
            />
          </div>
          {
            <DailyYeildDataProduction
              key={1}
              loading={loadingDaily}
              time_interval={time_interval}
              chartData={dailyChartData}
            />
          }
        </TabPane>
        <TabPane tabId="2">
          <MonthlyYeildDataProduction
            data={monthlyChartData}
            date_time={dateHOC}
          />
        </TabPane>
        <TabPane tabId="3">
          <YearlyYeildDataProduction
            data={yearlyChartData}
            date_time={dateHOC}

          // className="highChart2"
          // style={{ direction: "ltr !important" }}
          />
        </TabPane>
        <TabPane tabId="4">
          <TotalYeildDataProduction
            data={totalyChartData}
            date_time={dateHOC}

          // className="highChart2"
          // style={{ direction: "ltr !important" }}
          />
        </TabPane>
        {/* <TabPane tabId="5">
            <CompareYeildDataProduction
              data={data ? data.data.compare_chart : []}
              date_time={dateHOC}
            />
          </TabPane> */}
      </>
    );
    // }
  }

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            active={activeTab[0] === "1"}
            onClick={() => {
              toggle(0, "1");
            }}
          >
            {lang_choiced.pages.dashboard.finallyChart.daily.title}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={activeTab[0] === "2"}
            onClick={() => {
              toggle(0, "2");
            }}
          >
            {lang_choiced.pages.dashboard.finallyChart.monthly.title}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={activeTab[0] === "3"}
            onClick={() => {
              toggle(0, "3");
            }}
          >
            {lang_choiced.pages.dashboard.finallyChart.yearly.title}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={activeTab[0] === "4"}
            onClick={() => {
              toggle(0, "4");
            }}
          >
            {lang_choiced.pages.dashboard.finallyChart.total.title}
          </NavLink>
        </NavItem>
        {/* <NavItem>
          <NavLink
            active={activeTab[0] === "5"}
            onClick={() => {
              toggle(0, "5");
            }}
          >
            {lang_choiced.components.charts.TabPane.tabTitle.compare}
          </NavLink>
        </NavItem> */}
      </Nav>
      <TabContent activeTab={activeTab[0]}>{tabPane()}</TabContent>
    </div>
  );
};

export default React.memo(FinallyChart);
